import { useState } from 'react';

import { StayInputOverrides } from './otaParity/types';
import { useOtaRateShopOrchestration } from './useOtaRateShopOrchestration';

// Combines stay inputs and the in-flight/completed rate-shop job into one Scrape session slice.
export function useScrapeSession(offerId: string | undefined) {
  const [stayInputs, setStayInputs] = useState<StayInputOverrides | null>(null);
  const [renderedOfferId, setRenderedOfferId] = useState(offerId);
  const orchestration = useOtaRateShopOrchestration(offerId);

  // Cleared during render, not in an effect: StayInputsForm remounts on the same commit the offer
  // changes and reads its defaultValues then, so an effect would hand it the previous offer's
  // currency and FX rate and it would keep showing them.
  if (offerId !== renderedOfferId) {
    setRenderedOfferId(offerId);
    setStayInputs(null);
  }

  return { stayInputs, setStayInputs, offerId, ...orchestration };
}
